import React from 'react';
import { Switch, Redirect, useLocation } from 'react-router-dom';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import esLocale from 'date-fns/locale/es';
import theme from '../Theme/theme';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles';
import { CssBaseline } from '@material-ui/core';
import { Alertas } from '../components/ui/Alertas';
import Spinner from '../components/ui/BackDrop';
import { PrivateRoute } from './PrivateRoute';
import { PublicRoute } from './PublicRoute';
import { HomeScreen } from '../components/Home/HomeScreen';
import { LoginScreen } from '../components/auth/LoginScreen';
import CambioContraseñaUsuario from '../components/auth/CambioContraseñaUsuario';
import AppNavbar from '../components/bar/AppNavBar';
import { AfiliacionesScreen } from '../components/afiliaciones/AfiliacionesScreen';
import { HomeDocumentTipo } from '../components/configuracion/documentoTipo/HomeDocumentoTipo';
import { HomeTiposDeAfiliacion } from '../components/configuracion/tiposAfiliacion/HomeTiposDeAfiliacion';
import { HomeCategoria } from '../components/configuracion/CategoriasABM/HomeCategoria';
import { HomeTiposDeDocumentaciones } from '../components/configuracion/tipoDocumentaciones/HomeTipoDeDocumentaciones';
import { HomeTiposDeDocumentosParentescos } from '../components/configuracion/documentoParentesco/HomeTipoDeDocumentosParentescos';
import { HomeTiposParentescos } from '../components/configuracion/TipoParentescoABM/HomeTiposParentescos';
import { HomeUsuarios } from '../components/configuracion/usuarios/HomeUsuarios';
import { HomeRoles } from '../components/configuracion/roles/HomeRoles';
import { HomeBandeja } from '../components/afiliaciones/bandeja/HomeBandeja';
import { HomeCategoriaRelacion } from '../components/configuracion/relacionCategoriaTipoRelacion/HomeCategoriaRelacion';
import { AdministrarPreAfiliaciones } from '../components/administrarPreAfiliaciones/AdministrarPreAfiliaciones';
import { HomeEstadoCivil } from '../components/configuracion/EstadoCivilABM/HomeEstadoCivil';
import { Home } from '../components/autogestion/Home';
import { HomeEstadoEnvio } from '../components/autogestion/HomeEstadoEnvio';
import { EmpresasScreen } from '../components/empresas/EmpresasScreen';
import HomePermisos from '../components/configuracion/permisos/HomePermisos';
import OferentesScreen from '../components/Compras/configuraciones/oferentesABM/OferentesScreen';
import {
  ADMINISTRAR_PREAFILIACIONES_PERMISOS,
  AFILIACIONES_PERMISOS,
  BANDEJA_PERMISOS,
  CATEGORIA_PERMISOS,
  CATEGORIA_TIPO_AFILIADO_PERMISOS,
  DOCUMENTOS_PARENTESCO_PERMISOS,
  DOCUMENTOS_TIPO_PERMISOS,
  EMPRESAS_PERMISOS,
  ESTADO_CIVIL_PERMISOS,
  PERMISOS_PERMISOS,
  ROLES_PERMISOS,
  TIPO_AFILIACION_PERMISOS,
  TIPO_PARENTESCO_PERMISOS,
  USUARIOS_PERMISOS,
  REPORTES_PERMISOS,
  MOVIMIENTOSUSER_PERMISOS,
  TURNOS_PERMISOS,
  CONFIGURACIONTURNOS_PERMISOS,
  SOPORTEAFILIADOS_PERMISOS,
  ARCHIVOS_PERMISOS,
  CONTRATACIONES_PERMISOS,
  ESPECIALIDADES_PERMISOS,
  RESOLUCIONESFACTURACION_PERMISOS,
  CUOTASFACTURACION_PERMISOS,
  FACTURACION_PERMISOS,
  ESTADISTICAS_MI_OSPEDYC,
  AUTORIZACIONES_MENU_PERMISOS,
  ADMINISTRAR_AUTORIZACIONES_PERMISOS,
  ADMINISTRAR_PRESUPUESTOS_PERMISOS,
  REPORTE_DINAMICO_PERMISOS,
  MESA_ENTRADA_PERMISOS,
  ARCHIVOS_CONTRATACIONES,
  EFECTORES_LIQUIDADOR_PERMISOS,
  RECETAS_MENU_PERMISOS,
  LIQUIDACIONES_MENU_PERMISOS,
  ADMINISTRAR_LIQUIDACIONES_PERMISOS,
  EMPADRONAMIENTO_MENU_PERMISOS,
  MEDICACION_MENU_PERMISOS,
  ADMINISTRAR_DISCAPACIDAD_PERMISOS,
  TIPOS_DOCUMENTACION,
  TIPOS_DOCUMENTACION_SOLICITUD,
  TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD,
  MATERIALES,
  TIPOS_DOCUMENTACION_PRESUPUESTO,
  RECLAMOS_PERMISOS,
  TOTEM_PERMISOS,
  RECUPERO,
  HCE_PERMISOS,
  ADMINISTRAR_ADICCIONES_PERMISOS,
  AUTORIZACIONES_PRACTICAS_AGRUPADAS,
  TESORERIA_PERMISOS,
  TOTEM_BASIC_PERMISOS,
} from '../utils/permisos';
import { HomeReportes } from '../components/reportes/HomeReportes';
import ConsultasGrid from '../components/ConsultasGrid/ConsultasGrid';
import { HomeContactos } from '../components/contactosWeb/HomeContactos';
import { HomeMovimientosUser } from '../components/movimientosUser/HomeMovimientosUser';
import { EstadoConfirmado } from '../components/autogestion/EstadoConfirmado';
import { HomeTurnos } from '../components/turnos/HomeTurnos';
import { HomeMotivosBajaTurnos } from '../components/configuracion/turnos/motivosBajaTurno/HomeMotivosBajaTurnos';
import { HomeParametrizacionHorarios } from '../components/configuracion/turnos/parametrizaciones/HomeParametrizacionHorarios';
import { HomeFeriados } from '../components/configuracion/turnos/feriados/HomeFeriados';
import { HomeAltaDiaEventual } from '../components/configuracion/turnos/altaDiaEventual/HomeAltaDiaEventual';
import SoporteDatosContacto from '../components/soporteAfiliados/SoporteDatosContacto';
import SubidaArchivosScreen from '../components/SubidaArchivos/SubidaArchivosScreen';
import { EspecialidadesAbmScreen } from '../components/configuracion/EspecialidadesABM/EspecialidadesAbmScreen';
import { HomeParametrizacionSobreturnos } from '../components/configuracion/turnos/sobreturnos/HomeParametrizacionSobreturnos';
import { TipoDocumentacionesEfectorPorSubtipoEfectorScreen } from '../components/Contratos/configuraciones/TipoDocumentacionesEfectorPorSubtipoEfector/TipoDocumentacionesEfectorPorSubtipoEfectorScreen';
import { HomeLicenciasProfesionales } from '../components/configuracion/turnos/licenciasProfesionales/HomeLicenciasProfesionales';
import { HomeContrataciones } from '../components/Contratos/HomeContrataciones';
import { HomeResoluciones } from '../components/configuracion/facturacion/resoluciones/HomeResoluciones';
import { HomeCuotas } from '../components/configuracion/facturacion/cuotas/HomeCuotas';
import { HomeFacturacion } from '../components/facturacion/HomeFacturacion';
import { TopesAbmScreen } from '../components/configuracion/topesMinimosABM/TopesAbmScreen';
import { HomeMotivosBajaEfector } from '../components/Contratos/configuraciones/MotivosBajaEfectorABM/HomeMotivosBajaEfector';
import { HomeReportesPorArea } from '../components/configuracion/reportesPorArea/HomeReportesPorArea';
import GeneralesScreen from '../components/miOspedyc/EstadisticasMiOspedyc/GeneralesScreen';
import UsuariosScreen from '../components/miOspedyc/UsuariosScreen';
import CategoriasScreen from '../components/miOspedyc/formularios/CategoriasScreen';
import { CuponPago } from '../components/facturacion/consultaCtaCte/CuponPago';
import { AutorizacionesHome } from '../components/autorizaciones/AutorizacionesHome';
import RedScreen from '../components/Contratos/reportes/redes/RedScreen';
import NomencladorScreen from '../components/Contratos/configuraciones/Nomenclador/NomencladorScreen';
import HomeModulos from '../components/Contratos/configuraciones/modulosAbm/HomeModulos';
import HomeCoseguros from '../components/Contratos/configuraciones/cosegurosAbm/HomeCoseguros';
import PrestadoresScreen from '../components/Contratos/reportes/prestadores/PrestadoresScreen';
import PrestadoresPorPracticas from '../components/Contratos/reportes/prestadoresPorPracticas/PrestadoresPorPracticasScreen';
import { AdministrarSolicitudes } from '../components/autorizaciones/administrarSolicitudes/AdministrarSolicitudes';
import { AbmPracticaBandejaHome } from '../components/autorizaciones/configuracion/abmPracticaBandeja/AbmPracticaBandejaHome';
import { AbmEfectorAuditoriaTerrenoHome } from '../components/autorizaciones/configuracion/abmEfectorAuditoriaTerreno/AbmEfectorAuditoriaTerrenoHome';
import HomeMateriales from '../components/autorizaciones/configuracion/materialesAbm/HomeMateriales';
import { AbmTiposDocumentacionSolicitudHome } from '../components/autorizaciones/configuracion/abmTiposDocumentacionSolicitud/AbmTiposDocumentacionSolicitudHome';
import { AbmTiposDocumentacionPracticaSolicitudHome } from '../components/autorizaciones/configuracion/abmTiposDocumentacionPracticaSolicitud/AbmTiposDocumentacionPracticaSolicitudHome';
import { AbmTiposDocumentacionHome } from '../components/autorizaciones/configuracion/abmTiposDocumentacion/AbmTiposDocumentacionHome';
import { AbmTiposDocumentacionPresupuestoHome } from '../components/autorizaciones/configuracion/abmTiposDocumentacionPresupuesto/AbmTiposDocumentacionPresupuestoHome';
import { HomeParametrizacionUsuarioOspe } from '../components/configuracion/turnos/usuarioOspe/HomeParametrizacionUsuarioOspe';
import { AdministrarPresupuestos } from '../components/autorizaciones/administrarPresupuestos/AdministrarPresupuestos';
import { MesaEntradaHome } from '../components/MesaEntrada/MesaEntradaHome';
import ArchivosContratacionesScreen from '../components/SubidaArchivos/ArchivosContratacionesScreen';
import { HomeEfectoresPorLiquidador } from '../components/configuracion/efectoresPorLiquidador/HomeEfectoresPorLiquidador';
import FormulariosScreen from '../components/miOspedyc/formularios/FormulariosScreen';
import { RecetasDigitalesHome } from '../components/recetasDigitales/RecetasDigitalesHome';
import { LiquidacionesHome } from '../components/liquidaciones/LiquidacionesHome';
import { AdministrarLiquidaciones } from '../components/liquidaciones/administrarLiquidaciones/AdministrarLiquidaciones';
import { CotizacionesHome } from '../components/Compras/Cotizaciones/CotizacionesHome';
import ProveedoresScreen from '../components/Compras/configuraciones/proveedoresABM/ProveedoresScreen';
import { RecetasDigitalesMedicamentosABM } from '../components/recetasDigitales/configuracion/Medicamentos/RecetasDigitalesMedicamentosABM';
import CredencialesRecetasDigitalesUsuario from '../components/auth/CredencialesRecetasDigitalesUsuario';
import { HomeCud } from '../components/Discapacidad/Home/HomeCud';
import { ConfiguracionesCud } from '../components/Discapacidad/Configuraciones/ConfiguracionesCud';
import { ArchivosCud } from '../components/Discapacidad/Archivos/ArchivosCud';
import { AdministrarSolicitudesIntegracion } from '../components/Discapacidad/Home/components/AdministrarSolicitudesIntegracion';
import themeTotem from '../Theme/themeTotem';
// import { TotemHome } from "../components/TotemTurnos/TotemHome";
import { EmpadronamientoHome } from '../components/empadronamiento/EmpadronamientoHome';
import { MedicacionHome } from '../components/empadronamiento/MedicacionHome';
import { useSelector } from 'react-redux';
import { HomeIngresoPlazos } from '../components/Contratos/configuraciones/TiposPlazoABM/HomeIngresoPlazos';
import { TotemHome } from '../components/TotemTurnos/TotemHome';
import { HomeRecuperos } from '../components/Recuperos/HomeRecuperos';
import { ArchivosRecuperos } from '../components/Recuperos/ArchivosRecuperos';
import HomePatologias from '../components/Recuperos/Configuracion/Patologias/HomePatologias';
import { AbmConceptos } from '../components/Recuperos/Configuracion/AbmConceptos';
import { HomeMedicamentos310 } from '../components/empadronamiento/configuracion/medicamentos310/HomeMedicamentos310';
import { MedicosAbmScreenNew } from '../components/configuracion/MedicosABM/MedicosAbmScreenNew';
import { ReclamosHome } from '../components/Reclamos/ReclamosHome';
import { MenuGestionReclamos } from '../components/Reclamos/GestionReclamos/MenuGestionReclamos';
import { TotemOpcionesABM } from '../components/TotemTurnos/Configuration/TotemOpcionesABM';
import { TotemSubOpcionesABM } from '../components/TotemTurnos/Configuration/TotemSubOpcionesABM';
import { TotemRecepcionABM } from '../components/TotemTurnos/Configuration/TotemRecepcionABM';
import { validarSoloUnPermiso } from '../helpers/permisos';
import { TotemRecepcionistasHome } from '../components/TotemTurnos/Admin/TotemRecepcionistasHome';
import { AutoPercepcion } from '../components/configuracion/turnos/autopercepcion/AutoPercepcion';
import { SolicitudesAfiliadosReports } from '../components/TotemTurnos/Reports/SolicitudesAfiliadosReports';
import { NomencladorDiscapacidad } from '../components/Discapacidad/Configuraciones/pages/NomencladorDiscapacidad';
import { ComunicacionConEmpresasHome } from '../components/comunicacionConEmpresas/ComunicacionConEmpresasHome';
import { HomeRecupero } from "../components/autorizaciones/configuracion/recuperoAbm/HomeRecupero";
import { TramitesDestinosABM } from '../components/MesaEntrada/Config/TramitesDestinosABM';
import { HomeHCE } from '../components/HCE/HomeHCE';
import { HomeAbmInformes } from '../components/HCE/Configuracion/AbmInformes/HomeAbmInformes';
import { AbmPracticasYDispositivos } from "../components/Recuperos/Configuracion/AbmPracticasYDispositivos";
import { Teleconsulta } from '../components/HCE/telemedicina/Teleconsulta';
import { TrasladosHome } from '../components/Traslados/TrasladosHome';
import { TipoDocumentacionSolicitudTraslados } from '../components/Traslados/configuration/TipoDocumentacionSolicitudTraslados';
import { GestionSolicitudes } from '../components/Traslados/GestionSolicitudes/GestionSolicitudes';
import { HomeCosegurosExternos } from '../components/Contratos/configuraciones/cosegurosExternosAbm/HomeCosegurosExternos';
import { ModificacionInternacionesHome } from '../components/autorizaciones/modificacionInternaciones/ModificacionInternacionesHome';
import { AbmPrestadoresRestringidosHome } from '../components/autorizaciones/configuracion/abmPrestadoresRestringidos/AbmPrestadoresRestringidosHome';
import { TotemTurnosRecepciones } from '../components/TotemTurnos/Configuration/TotemTurnosRecepciones';
import { RemitoHome } from '../components/MesaEntrada/Remitos/RemitoHome';
import { HomeVersionesSistema } from '../components/versionesSistema/HomeVersionesSistema';
import { ModificacionesAfiHome } from '../components/afiliaciones/modificaciones/ModificacionesAfiHome';
import { HomeAbmInformeOftalmologia } from '../components/HCE/Configuracion/abmInformesOftalmologia/HomeAbmInformeOftalmologia';
import { HomeEstudiosMedicos } from '../components/HCE/Configuracion/abmEstudiosMedicos/HomeEstudiosMedicos';
import { CertificadoAtencion } from '../components/turnos/certificadoAtencion/CertificadoAtencion';
import { HomeAdicciones } from '../components/adicciones/Home/HomeAdicciones';
import { AdministrarSolicitudesAdicciones } from '../components/adicciones/Home/components/AdministrarSolicitudesAdicciones';
import { HomePracticasAgrupadas } from '../components/autorizaciones/practicasAgrupadas/HomePracticasAgrupadas';
import { HorariosMedicosHome } from '../components/turnos/horariosMedicos/HorariosMedicosHome';
import { InicioBandejaMedicacionHome } from '../components/empadronamiento/gestionMedicacion/InicioBandejaMedicacionHome';
import { AdministrarReclamos } from '../components/Reclamos/AdministrarReclamos';
import { UsuariosOspeDirectoHome } from '../components/tesoreria/usuariosOspedycDirecto/UsuariosOspeDirectoHome';
import { TotemBasicHome } from '../components/totemBasic/TotemBasicHome';
import { AbmBox } from '../components/totemBasic/Configuracion/AbmBox/AbmBox';
import { AbmOpcionesTotemBasic } from '../components/totemBasic/Configuracion/AbmOpciones/AbmOpcionesTotemBasic';
import { AbmSubOpcionesTotemBasic } from '../components/totemBasic/Configuracion/AbmSubOpciones/AbmSubOpcionesTotemBasic';
import { AbmOpcionesPorBox } from '../components/totemBasic/Configuracion/AbmOpcionesPorBox/AbmOpcionesPorBox';
import { GestionTotemBasic } from '../components/totemBasic/Gestion/GestionTotemBasic';
import { AfiliadosRecuperoHome } from '../components/autorizaciones/afiliadosRecupero/AfiliadosRecuperoHome';
import { AbmTiposDocumentacionRecuperoHome } from '../components/autorizaciones/configuracion/abmTipoDocumentacionRecupero/AbmTiposDocumentacionRecuperoHome';

export const AppRouter = () => {
  const location = useLocation();

  const { permisos } = useSelector((state) => state.auth);

  return (
    <MuiThemeProvider
      theme={(location.pathname !== '/totem' || location.pathname !== '/totemBasic') ? theme : themeTotem}
    >
      <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
        <CssBaseline />
        <Alertas />
        <Spinner />
        <div>
          {permisos !== null &&
            !validarSoloUnPermiso(permisos, TOTEM_PERMISOS.ACCESO) &&
            !validarSoloUnPermiso(permisos, TOTEM_BASIC_PERMISOS.ACCESO) &&
            (
              <AppNavbar />
            )}
          <Switch>
            <PublicRoute path="/auth/login" component={LoginScreen} />
            <PublicRoute
              exact
              path="/afiliaciones/AutoGestion/:cuil"
              isAuthenticated={false}
              component={Home}
            />
            <PublicRoute
              exact
              path="/afiliaciones/AutoGestion/estado/preinscripto"
              isAuthenticated={false}
              component={HomeEstadoEnvio}
            />
            <PublicRoute
              exact
              path="/afiliaciones/AutoGestionConfirmacion/:cuil"
              isAuthenticated={false}
              component={EstadoConfirmado}
            />
            <PublicRoute
              noRedirect={true}
              path="/facturacion/cuponAfiliado/:idCupon"
              component={CuponPago}
            />
            <PrivateRoute
              exact
              path="/"
              component={
                permisos !== null && validarSoloUnPermiso(permisos, TOTEM_PERMISOS.ACCESO)
                  ? TotemHome :
                  permisos !== null && validarSoloUnPermiso(permisos, TOTEM_BASIC_PERMISOS.ACCESO)
                    ? TotemBasicHome :
                    HomeScreen
              }
            />
            <PrivateRoute
              exact
              path="/afiliaciones"
              component={AfiliacionesScreen}
              permisos={AFILIACIONES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/Consultas"
              permisos={REPORTE_DINAMICO_PERMISOS}
              component={ConsultasGrid}
            />
            <PrivateRoute
              exact
              path="/contrataciones"
              permisos={CONTRATACIONES_PERMISOS}
              component={HomeContrataciones}
            />
            <PrivateRoute
              exact
              path="/contrataciones/reportes/redes"
              permisos={CONTRATACIONES_PERMISOS}
              component={RedScreen}
            />
            <PrivateRoute
              exact
              path="/contrataciones/reportes/prestadores"
              component={PrestadoresScreen}
            />
            <PrivateRoute
              exact
              path="/contrataciones/reportes/prestadores-por-practica"
              component={PrestadoresPorPracticas}
            />
            <PrivateRoute
              exact
              path="/contrataciones/archivos-contratos"
              permisos={ARCHIVOS_CONTRATACIONES}
              component={ArchivosContratacionesScreen}
            />
            {/* <PrivateRoute
              exact
              path="/medicos"
              permisos={MEDICOS_PERMISOS}
              component={MedicosAbmScreen}
            /> */}
            <PrivateRoute
              exact
              path="/medicos"
              component={MedicosAbmScreenNew}
            />
            <PrivateRoute
              exact
              path="/especialidades"
              permisos={ESPECIALIDADES_PERMISOS}
              component={EspecialidadesAbmScreen}
            />
            <PrivateRoute
              exact
              path="/contrataciones/configuracion/tipo-documentaciones-efector-por-subtipo-efector"
              permisos={CONTRATACIONES_PERMISOS}
              component={TipoDocumentacionesEfectorPorSubtipoEfectorScreen}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/configuracionTipo"
              component={HomeDocumentTipo}
              permisos={DOCUMENTOS_TIPO_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/tiposAfiliacion"
              component={HomeTiposDeAfiliacion}
              permisos={TIPO_AFILIACION_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/tiposCategoria"
              component={HomeCategoria}
              permisos={CATEGORIA_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/tiposDeDocumentaciones"
              component={HomeTiposDeDocumentaciones}
              permisos={DOCUMENTOS_TIPO_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/configuracionCategoriaXAfiliado"
              component={HomeCategoriaRelacion}
              permisos={CATEGORIA_TIPO_AFILIADO_PERMISOS}
            />
            <PrivateRoute
              exactuario
              path="/afiliaciones/configuracionParentesco"
              component={HomeTiposDeDocumentosParentescos}
              permisos={DOCUMENTOS_PARENTESCO_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/tiposParentesco"
              component={HomeTiposParentescos}
              permisos={TIPO_PARENTESCO_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/migracion-archivos"
              permisos={ARCHIVOS_PERMISOS}
              component={SubidaArchivosScreen}
            />
            <PrivateRoute
              exact
              path="/empresas"
              component={EmpresasScreen}
              permisos={EMPRESAS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/usuarios/usuario"
              component={HomeUsuarios}
              permisos={USUARIOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/usuarios/roles"
              component={HomeRoles}
              permisos={ROLES_PERMISOS}
            />

            <PrivateRoute
              exact
              path="/usuarios/permisos"
              component={HomePermisos}
              permisos={PERMISOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/bandeja"
              component={HomeBandeja}
              permisos={BANDEJA_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/usuarios/administrarPreafiliaciones"
              component={AdministrarPreAfiliaciones}
              permisos={ADMINISTRAR_PREAFILIACIONES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/estadoCivil"
              component={HomeEstadoCivil}
              permisos={ESTADO_CIVIL_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/estadoCivil"
              component={HomeEstadoCivil}
              permisos={MOVIMIENTOSUSER_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/turnos/parametrizacionHorarios"
              component={HomeParametrizacionHorarios}
              permisos={CONFIGURACIONTURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/turnos/horariosMedicos"
              component={HorariosMedicosHome}
              permisos={CONFIGURACIONTURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/turnos/parametrizacionSobreTurnos"
              component={HomeParametrizacionSobreturnos}
              permisos={CONFIGURACIONTURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/turnos/parametrizacionUsuarioOspe"
              component={HomeParametrizacionUsuarioOspe}
              permisos={CONFIGURACIONTURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/turnos/motivosBajaTurnos"
              component={HomeMotivosBajaTurnos}
              permisos={CONFIGURACIONTURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/turnos/autopercepcion"
              component={AutoPercepcion}
              permisos={TURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/turnos/feriados"
              component={HomeFeriados}
              permisos={CONFIGURACIONTURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/turnos/altaDiaEventual"
              component={HomeAltaDiaEventual}
              permisos={CONFIGURACIONTURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/turnos/licenciasProfesionales"
              component={HomeLicenciasProfesionales}
              permisos={CONFIGURACIONTURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/facturacion/resoluciones"
              component={HomeResoluciones}
              permisos={RESOLUCIONESFACTURACION_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/configuracion/facturacion/cuotas"
              component={HomeCuotas}
              permisos={CUOTASFACTURACION_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/facturacion"
              component={HomeFacturacion}
              permisos={FACTURACION_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/turnos"
              component={HomeTurnos}
              permisos={TURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/turnos/certificadoAtencion"
              component={CertificadoAtencion}
              permisos={TURNOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/reportes"
              component={HomeReportes}
              permisos={REPORTES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/contactosWeb"
              component={HomeContactos}
              permisos={REPORTES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/usuarios/movimientos"
              component={HomeMovimientosUser}
              permisos={REPORTES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/soporte-afiliados/contacto"
              component={SoporteDatosContacto}
              permisos={SOPORTEAFILIADOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/cambio-contraseña"
              component={CambioContraseñaUsuario}
            />
            <PrivateRoute
              exact
              path="/credenciales-recetas"
              component={CredencialesRecetasDigitalesUsuario}
            />
            <PrivateRoute
              exact
              path="/TopesMinimos"
              component={TopesAbmScreen}
            />
            <PrivateRoute
              exact
              path="/contrataciones/configuracion/MotivosBajaEfector"
              component={HomeMotivosBajaEfector}
            />
            <PrivateRoute
              exact
              path="/contrataciones/configuracion/modulos"
              component={HomeModulos}
              permisos={CONTRATACIONES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/contrataciones/configuracion/nomenclador"
              component={NomencladorScreen}
              permisos={CONTRATACIONES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/contrataciones/configuracion/coseguros"
              component={HomeCoseguros}
            />
            <PrivateRoute
              exact
              path="/contrataciones/configuracion/cosegurosExternos"
              component={HomeCosegurosExternos}
            />
            <PrivateRoute
              exact
              path="/ReportesPorArea"
              component={HomeReportesPorArea}
            />
            <PrivateRoute
              exact
              path="/estadisticas-mi-ospedyc/generales"
              component={GeneralesScreen}
              permisos={ESTADISTICAS_MI_OSPEDYC}
            />
            <PrivateRoute
              exact
              path="/estadisticas-mi-ospedyc/usuarios"
              component={UsuariosScreen}
              permisos={ESTADISTICAS_MI_OSPEDYC}
            />
            <PrivateRoute
              exact
              path="/mi-ospedyc/categorias"
              component={CategoriasScreen}
              permisos={ESTADISTICAS_MI_OSPEDYC}
            />
            <PrivateRoute
              exact
              path="/mi-ospedyc/formularios"
              component={FormulariosScreen}
              permisos={ESTADISTICAS_MI_OSPEDYC}
            />
            <PrivateRoute
              exact
              path="/autorizaciones"
              component={AutorizacionesHome}
              permisos={AUTORIZACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/administrarSolicitudes"
              component={AdministrarSolicitudes}
              permisos={ADMINISTRAR_AUTORIZACIONES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/administrarPresupuestos"
              component={AdministrarPresupuestos}
              permisos={ADMINISTRAR_PRESUPUESTOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/modificacionInternaciones"
              component={ModificacionInternacionesHome}
              permisos={AUTORIZACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/afiliadosRecupero"
              component={AfiliadosRecuperoHome}
              permisos={AUTORIZACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/practicasAgrupadas"
              component={HomePracticasAgrupadas}
              permisos={AUTORIZACIONES_PRACTICAS_AGRUPADAS}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/RelacionPracticaBandeja"
              component={AbmPracticaBandejaHome}
              permisos={AUTORIZACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/efectoresAuditoriaTerreno"
              component={AbmEfectorAuditoriaTerrenoHome}
              permisos={AUTORIZACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/tiposDocumentacion"
              component={AbmTiposDocumentacionHome}
              permisos={TIPOS_DOCUMENTACION}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/tiposDocumentacionPresupuesto"
              component={AbmTiposDocumentacionPresupuestoHome}
              permisos={TIPOS_DOCUMENTACION_PRESUPUESTO}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/tiposDocumentacionRecupero"
              component={AbmTiposDocumentacionRecuperoHome}
              permisos={TIPOS_DOCUMENTACION_PRESUPUESTO}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/tiposDocumentacionSolicitud"
              component={AbmTiposDocumentacionSolicitudHome}
              permisos={TIPOS_DOCUMENTACION_SOLICITUD}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/tiposDocumentacionPracticaSolicitud"
              component={AbmTiposDocumentacionPracticaSolicitudHome}
              permisos={TIPOS_DOCUMENTACION_PRACTICA_SOLICITUD}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/materiales"
              component={HomeMateriales}
              permisos={MATERIALES}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/recupero"
              component={HomeRecupero}
              permisos={RECUPERO}
            />
            <PrivateRoute
              exact
              path="/autorizaciones/prestadoresRestringidos"
              component={AbmPrestadoresRestringidosHome}
              permisos={AUTORIZACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/traslados"
              component={TrasladosHome}
            // permisos={AUTORIZACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/traslados/gestionSolicitudes"
              component={GestionSolicitudes}
            // permisos={AUTORIZACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/traslados/configuracion/tipo-documentacion-solicitudes"
              component={TipoDocumentacionSolicitudTraslados}
            // permisos={AUTORIZACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/recetasDigitales"
              component={RecetasDigitalesHome}
              permisos={RECETAS_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/recetasDigitales/configuracion"
              component={RecetasDigitalesMedicamentosABM}
              permisos={RECETAS_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/liquidaciones"
              component={LiquidacionesHome}
              permisos={LIQUIDACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/liquidaciones/administrarLiquidaciones"
              component={AdministrarLiquidaciones}
              permisos={ADMINISTRAR_LIQUIDACIONES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/mesa-entrada/home"
              component={MesaEntradaHome}
              permisos={MESA_ENTRADA_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/mesa-entrada/remitos"
              component={RemitoHome}
              permisos={MESA_ENTRADA_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/mesa-entrada/configuracion/tramites-destinos"
              component={TramitesDestinosABM}
              permisos={MESA_ENTRADA_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/efectoresPorLiquidador"
              component={HomeEfectoresPorLiquidador}
              permisos={EFECTORES_LIQUIDADOR_PERMISOS}
            />
            <PrivateRoute exact path="/compras" component={CotizacionesHome} />
            <PrivateRoute exact path="/discapacidad/home" component={HomeCud} />
            <PrivateRoute
              exact
              path="/discapacidad/configuracion/:section"
              component={ConfiguracionesCud}
            />
            <PrivateRoute
              exact
              path="/discapacidad/archivos/:section"
              component={ArchivosCud}
            />
            <PrivateRoute
              exact
              path="/discapacidad/nomenclador"
              component={NomencladorDiscapacidad}
              permisos={false}
            />
            <PrivateRoute
              exact
              path="/compras/configuracion/oferentes"
              component={OferentesScreen}
            />
            <PrivateRoute
              exact
              path="/compras/configuracion/proveedores"
              component={ProveedoresScreen}
            />
            <PrivateRoute exact path="/totem" component={TotemHome} />


            <PrivateRoute exact path="/adicciones/home" component={HomeAdicciones} />
            <PrivateRoute
              exact
              path="/:programa/empadronamiento"
              component={EmpadronamientoHome}
              permisos={EMPADRONAMIENTO_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/:programa/continuidad"
              component={MedicacionHome}
              permisos={EMPADRONAMIENTO_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/:programa/inicio"
              component={InicioBandejaMedicacionHome}
              permisos={EMPADRONAMIENTO_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/adicciones/administrarSolicitudes"
              component={AdministrarSolicitudesAdicciones}
              permisos={ADMINISTRAR_ADICCIONES_PERMISOS}
            />

            <PrivateRoute
              exact
              path="/medicacion"
              component={MedicacionHome}
              permisos={MEDICACION_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/liquidaciones"
              component={LiquidacionesHome}
              permisos={LIQUIDACIONES_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/liquidaciones/administrarLiquidaciones"
              component={AdministrarLiquidaciones}
              permisos={ADMINISTRAR_LIQUIDACIONES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/mesaEntrada"
              component={MesaEntradaHome}
              permisos={MESA_ENTRADA_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/efectoresPorLiquidador"
              component={HomeEfectoresPorLiquidador}
              permisos={EFECTORES_LIQUIDADOR_PERMISOS}
            />
            <PrivateRoute exact path="/compras" component={CotizacionesHome} />
            <PrivateRoute exact path="/discapacidad/home" component={HomeCud} />
            <PrivateRoute
              exact
              path="/discapacidad/administrarSolicitudes"
              component={AdministrarSolicitudesIntegracion}
              permisos={ADMINISTRAR_DISCAPACIDAD_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/discapacidad/configuracion/:section"
              component={ConfiguracionesCud}
            />
            <PrivateRoute
              exact
              path="/discapacidad/archivos/:section"
              component={ArchivosCud}
            />
            <PrivateRoute
              exact
              path="/compras/configuracion/oferentes"
              component={OferentesScreen}
            />
            <PrivateRoute
              exact
              path="/compras/configuracion/proveedores"
              component={ProveedoresScreen}
            />
            <PrivateRoute
              component={HomeIngresoPlazos}
              exact
              path="/contrataciones/configuracion/TiposPlazos"
            />
            <PrivateRoute
              exact
              path="/surge/menu"
              component={HomeRecuperos}
            />
            <PrivateRoute
              exact
              path="/surge/archivos"
              component={ArchivosRecuperos}
            />
            <PrivateRoute
              exact
              path="/surge/configuraciones/patologias"
              component={HomePatologias}
            />
            <PrivateRoute
              exact
              path="/surge/configuraciones/practicasydispositivos"
              component={AbmPracticasYDispositivos}
            />
            <PrivateRoute
              exact
              path="/surge/configuraciones/conceptos"
              component={AbmConceptos}
            />
            <PrivateRoute
              exact
              path="/empadronamiento/medicacion310"
              component={HomeMedicamentos310}
              permisos={MEDICACION_MENU_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/reclamos/home"
              component={ReclamosHome}
              permisos={RECLAMOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/reclamos/configuracion/tiposreclamos"
              component={MenuGestionReclamos}
              permisos={RECLAMOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/reclamos/administrarReclamos"
              component={AdministrarReclamos}
              permisos={RECLAMOS_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/totem/opciones"
              component={TotemOpcionesABM}
            />
            <PrivateRoute
              exact
              path="/totem/sub-opciones"
              component={TotemSubOpcionesABM}
            />
            <PrivateRoute
              exact
              path="/totem/recepcion"
              component={TotemRecepcionABM}
            />
            <PrivateRoute
              exact
              path="/totem/turnosRecepciones"
              component={TotemTurnosRecepciones}
            />
            <PrivateRoute
              exact
              path="/totem/turnosRecepciones"
              component={TotemTurnosRecepciones}
            />
            <PrivateRoute
              exact
              path="/totem/administracion-recepcionista"
              component={TotemRecepcionistasHome}
            />
            <PrivateRoute
              exact
              path="/totem/reportes/solicitudes-afiliados"
              component={SolicitudesAfiliadosReports}
            />
            <PrivateRoute
              exact
              path="/comunicacion-con-empresas"
              component={ComunicacionConEmpresasHome}
            />
            <PrivateRoute
              exact
              path="/hce"
              component={HomeHCE}
              permisos={HCE_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/hce/teleconsulta"
              component={Teleconsulta}
              permisos={HCE_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/hce/abmInformes"
              component={HomeAbmInformes}
              permisos={HCE_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/hce/abmInformesOftalmo"
              component={HomeAbmInformeOftalmologia}
              permisos={HCE_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/hce/abmEstudiosMedicos"
              component={HomeEstudiosMedicos}
              permisos={HCE_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/versionesSistema"
              component={HomeVersionesSistema}
            />
            <PrivateRoute
              exact
              path="/afiliaciones/modificaciones"
              component={ModificacionesAfiHome}
              permisos={AFILIACIONES_PERMISOS}
            />
            <PrivateRoute
              exact
              path="/tesoreria/usuariosospedirecto"
              component={UsuariosOspeDirectoHome}
              permisos={TESORERIA_PERMISOS.CONFIGURACION}
            />
            <PrivateRoute
              exact
              path="/totemMoron"
              component={TotemBasicHome}
            />
            <PrivateRoute
              exact
              path="/totemMoron/bandeja"
              component={GestionTotemBasic}
            />
            <PrivateRoute
              exact
              path="/totemMoron/abmBoxes"
              component={AbmBox}
            />
            <PrivateRoute
              exact
              path="/totemMoron/abmOpciones"
              component={AbmOpcionesTotemBasic}
            />
            <PrivateRoute
              exact
              path="/totemMoron/abmSubOpciones"
              component={AbmSubOpcionesTotemBasic}
            />
            <PrivateRoute
              exact
              path="/totemMoron/abmOpcionesPorBox"
              component={AbmOpcionesPorBox}
            />
            <Redirect to="/auth/login" />
          </Switch>
        </div>
      </MuiPickersUtilsProvider>
    </MuiThemeProvider>
  );
};
